import React, { useState, useRef, useEffect } from "react";
import InputGroup from "react-bootstrap/InputGroup";
import "../../../src/main.css";
import Cross from "assets/svgs/cross";
import CardDiv from "modules/common/card-div/CardDiv";
import BulkUploadInVoices from "./BulkUploadInVoices";
import { useInvoiceStore } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import InvoiceHistoryTable from "./InvoiceHistoryTable";

function GenerateInvoice({tab}) {
  const [inputChange, setInputChange] = useState("");
  const {invoiceHisData,creditData,invHisLoading, postGenerateInvoice, fetchInvoiceHistory, fetchCreditHistory,postGenerateCreditNote}=useInvoiceStore();
  const {setToaster}=useToast();
  const [refresh, setRefresh]= useState(true);

  useEffect(()=>{
    if(tab=='invoice'){
        fetchInvoiceHistory();
    }
    else if(tab=='credit'){
        fetchCreditHistory();
    }
    setInputChange("");
  },[refresh,tab])


  const handleClick = () => {
    if(!inputChange){
      return;
    }
    if(tab==='invoice'){
        postGenerateInvoice({'orderDisplayId':inputChange}, setToaster,refresh, setRefresh)
    }
    else if(tab==='credit'){
        postGenerateCreditNote({'orderDisplayId':inputChange}, setToaster,refresh, setRefresh)
    }
  };

  const handleChange = (value) => {
    setInputChange(value);
  };

  const handleClear = () => {
    setInputChange("");
  };

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between align-items-center">
          <div className=" float-start">
            <InputGroup className="input-search rounded-left mt-n1">
              <div className="d-flex flex-fill border border-end-0 bg-white align-items-center pe-1 ps-2 rounded-left">
                <input
                  style={{ outline: 0 }}
                  onChange={(event) => {
                    handleChange(event.target.value);
                  }}
                  value={inputChange}
                  placeholder="Order display id"
                  className="border-0 w-100 "
                />
                {inputChange && (
                  <span onClick={handleClear} className="ms-n4">
                    <Cross />
                  </span>
                )}
              </div>
              <InputGroup.Text
                id="basic-addon2"
                className="bg-primary text-white fs-1 border-0"
                onClick={handleClick}
                style={{ cursor: "pointer" }}
              >
               {tab==='invoice'? "Generate Invoice":"Generate Credit Note"}
              </InputGroup.Text>
            </InputGroup>
          </div>
          <BulkUploadInVoices tab={tab}/>
        </div>
      }
      component={<InvoiceHistoryTable invoiceHisData={tab ==='invoice' ? invoiceHisData : creditData} tab={tab} invHisLoading={invHisLoading}
      />}
    />
  );
}

export default GenerateInvoice;
